export const MAX_WIDGET_IMAGES = 10;
export const MAX_WIDGET_IMAGE_BYTES = 2 * 1024 * 1024; // 2 MB
